// // import React, { useState, useRef } from "react";
// // import {
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Button,
// //   Paper,
// //   Box,
// //   Typography,
// //   TableSortLabel,
// // } from "@mui/material";
// // import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// // import DropDownFilter, { Option } from "./DropDownFilter";
// // import PaginationComponent from "../../brands/Pagination";

// // import Export from "../../../../src/assests/images/export.svg";
// // import Sorting from "../../../../src/assests/images/Sorting.svg";
// // import BulkUploadFilter from "./BulkuploadFilter";
// // import { exportSFAReport } from "./api";
// // import { getToken } from "../../../utils/utils";

// // export interface BulkSFATableProps {
// //   data: any[];
// //   loading: boolean;
// //   page:number;
// //   limit:number;
// //   totalRecords: number;
// //   setPage: (newPage: number) => void;
// // }

// // const columns: Option[] = [
// //   { label: "Id", value: "id" },
// //   { label: "PMI Entity Code", value: "pmi_entity_code" },
// //   { label: "Created At", value: "createdAt" },
// //   { label: "SFA ID", value: "sfa_id" },
// //   { label: "Branch", value: "branch" },
// //   { label: "M3 SFA Vol", value: "m3_sfa_vol" },
// //   { label: "M2 SFA Vol", value: "m2_sfa_vol" },
// //   { label: "Number of Bills Cut", value: "number_of_bills_cut" },
// //   { label: "Advance Vol", value: "advance_vol" },
// //   { label: "Fusebeyond Vol", value: "fusebeyond_vol" },
// //   { label: "Gold Vol", value: "gold_vol" },
// //   { label: "Red Vol", value: "red_vol" },
// //   { label: "Clovemix Vol", value: "clovemix_vol" },
// //   { label: "Finetouch Vol", value: "finetouch_vol" },
// //   { label: "Vista Doubleu Vol", value: "vista_doubleu_vol" },
// //   { label: "Filterblack Vol", value: "filterblack_vol" },
// //   { label: "Vistablue Vol", value: "vistablue_vol" },
// //   { label: "Vistamist Vol", value: "vistamist_vol" },
// //   { label: "Vista Taaza Vol", value: "vista_taaza_vol" },
// //   { label: "Vista Tropical Vol", value: "vista_tropical_vol" },
// //   { label: "Filterblack Kings Vol", value: "filterblack_kings_vol" },
// //   { label: "Compactad Vol", value: "compactad_vol" },
// //   { label: "Pocket Vol", value: "pocket_vol" },
// //   { label: "Parlgold Vol", value: "parlgold_vol" },
// //   { label: "Partltropical Vol", value: "partltropical_vol" },
// //   { label: "Combeeyond Vol", value: "combeeyond_vol" },
// //   {label:"TimeStamp",value:"timestamp"}, 
// //   // Workzoy & availability
// //   { label: "M3 Workzoy Ranging", value: "m3_workzoy_ranging" },
// //   { label: "M2 Workzoy Ranging", value: "m2_workzoy_ranging" },
// //   { label: "Advance Avl", value: "advance_avl" },
// //   { label: "Fusebeyond Avl", value: "fusebeyond_avl" },
// //   { label: "Gold Avl", value: "gold_avl" },
// //   { label: "Red Avl", value: "red_avl" },
// //   { label: "Clovemix Avl", value: "clovemix_avl" },
// //   { label: "Finetouch Avl", value: "finetouch_avl" },
// //   { label: "Vista Doubleu Avl", value: "vista_doubleu_avl" },
// //   { label: "Filterblack Avl", value: "filterblack_avl" },
// //   { label: "Vistablue Avl", value: "vistablue_avl" },
// //   { label: "Vistamist Avl", value: "vistamist_avl" },
// //   { label: "Vista Taaza Avl", value: "vista_taaza_avl" },
// //   { label: "Vista Tropical Avl", value: "vista_tropical_avl" },
// //   { label: "Filterblack Kings Avl", value: "filterblack_kings_avl" },
// //   { label: "Compactad Avl", value: "compactad_avl" },
// //   { label: "Pocket Avl", value: "pocket_avl" },
// //   { label: "Parlgold Avl", value: "parlgold_avl" },
// //   { label: "Combeeyond Avl", value: "combeeyond_avl" },
// //   { label: "Partltropical Avl", value: "partltropical_avl" },
// // ];
// // const token=getToken()
// // const defaultColumns = [ "id", "pmi_entity_code", "timestamp", "sfa_id", "branch", "advance_vol", "fusebeyond_vol", ];
// // const BulkSFATable: React.FC<BulkSFATableProps> = ({ data, loading,page,
// //   limit,
// //   totalRecords,
// //   setPage
// //  }) => {

// //   const [isPopupVisible, setIsPopupVisible] = useState(false);
// //   const popupRef = useRef<HTMLDivElement | null>(null);

// //   // default visible columns
// //   const [selectedCols, setSelectedCols] = useState<string[]>([
// //      "id",              // ✅ show Id
// //     "pmi_entity_code",
// //     "timestamp",
// //     "sfa_id",
// //     "branch",
// //     "advance_vol",     // ✅ correct value
// //     "fusebeyond_vol",
// //   ]);

// //   const [orderBy, setOrderBy] = useState<string>("timestamp");
// //   const [order, setOrder] = useState<"asc" | "desc">("asc");

// //   // Pagination
// //   const itemsPerPage = 10;
// //   const totalPages = Math.ceil(totalRecords / limit);


// //   // Sorting logic
// //   const handleSort = (property: keyof BulkSFATableProps) => {
// //     const isAsc = orderBy === property && order === "asc";
// //     setOrder(isAsc ? "desc" : "asc");
// //     setOrderBy(property);
// //   };

// // //   const sortedUsers = [...(data || [])].sort((a, b) => {
// // //     if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
// // //     if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
// // //     return 0;
// // //   });

// //   const paginatedUsers = (data|| []).slice(
// //     (page - 1) * itemsPerPage,
// //     page * itemsPerPage
// //   );
// //    const handleExportCSV = async () => {
// //     try {
// //       const res=await exportSFAReport(token)
// //        const url = window.URL.createObjectURL(new Blob([res.data]));
// //         const link = document.createElement("a");
// //         link.href = url;
// //         link.setAttribute("download", "sfa_report.xlsx"); // same as retailers
// //         document.body.appendChild(link);
// //         link.click();
// //     link.remove();
// //     } catch (error) {
// //       console.error("Export failed:", error);
// //     }
// //   };
// //   return (
// //     <Box
// //       sx={{ background: "#fff", borderRadius: "10px", border: "1px solid #cfcfcf" }}
// //     >
// //       {/* Header with filters */}
// //       <Box
// //         sx={{
// //           padding: "25px ",
// //           display: "flex",
// //           justifyContent: "space-between",
// //         }}
// //       >
// //         <Typography
// //           sx={{ fontSize: "16px", fontWeight: "600", marginTop: "10px" }}
// //         >
// //           {loading ? "loading..." : `Total ${data?.length || 0} Users`}
// //         </Typography>
// //         <Box sx={{ display: "flex" }}>
// //           <Box sx={{ width: "200px", marginRight: "20px" }}>
// //             <DropDownFilter
// //     placeholder="Select columns"
// //     options={columns}
// //               value={selectedCols}
// //               onChange={(cols) => {
// //                 if (cols.includes("*ALL*")) {
// //                   // ⭐ Select All logic
// //                   if (selectedCols.length === columns.length) {
// //                     setSelectedCols(defaultColumns); // deselect → reset to default
// //                   } else {
// //                     setSelectedCols(columns.map((c) => c.value)); // select all
// //                   }
// //                 } else if (cols.length === 0) {
// //                   setSelectedCols(defaultColumns); // ⭐ empty → reset to default
// //                 } else {
// //                   setSelectedCols(cols);
// //                 }
// //               }}
// // />

// //           </Box>
// //           {/* <Button
// //             variant="contained"
// //             onClick={() => setIsPopupVisible((prev) => !prev)}
// //             sx={{
// //               textTransform: "capitalize",
// //               backgroundColor: "#fff",
// //               height: "44px",
// //               padding: "7px 12px",
// //               borderRadius: "4px",
// //               color: "#565656",
// //               border: "1px solid #DEDEDE",
// //               boxShadow: "none",
// //               marginRight: "20px",
// //               "&:hover": { backgroundColor: "#fff" },
// //             }}
// //             endIcon={<ExpandMoreIcon sx={{ fontSize: "30px" }} />}
// //           >
// //             Filters
// //           </Button>
// //           {isPopupVisible && (
// //             <div ref={popupRef}>
// //               <BulkUploadFilter />
// //             </div>
// //           )} */}
// //           <Button
// //             variant="contained"
// //             sx={{
// //               textTransform: "capitalize",
// //               backgroundColor: "#fff",
// //               fontSize: "14px",
// //               fontWeight: "500",
// //               height: "40px",
// //               padding: "16px",
// //               borderRadius: "10px",
// //               color: "#C8172F",
// //               border: "1px solid #C8172F",
// //               boxShadow: "none",
// //             }}
// //             startIcon={<img src={Export} alt="export" />}
// //             onClick={handleExportCSV} 
// //           >
// //             Export CSV
// //           </Button>
// //         </Box>
// //       </Box>

// //       {/* Table */}
// //       <Box>
// //         <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
// //           <Table>
// //             <TableHead sx={{ background: "#EEF4FF" }}>
// //               <TableRow>
// //                 {columns
// //                   .filter((col) => selectedCols.includes(col.value))
// //                   .map((col) => (
// //                     <TableCell key={col.value}>
// //                       <TableSortLabel
// //                         active={orderBy === col.value}
// //                         direction={orderBy === col.value ? order : "asc"}
// //                         onClick={() =>
// //                           handleSort(col.value as keyof BulkSFATableProps)
// //                         }
// //                         IconComponent={() => (
// //                           <img
// //                             src={Sorting}
// //                             alt="sort"
// //                             style={{ width: 16, height: 16 }}
// //                           />
// //                         )}
// //                       >
// //                         {col.label}
// //                       </TableSortLabel>
// //                     </TableCell>
// //                   ))}
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {paginatedUsers.map((row, rowIndex) => (
// //                 <TableRow key={rowIndex}>
// //                   {columns
// //                     .filter((col) => selectedCols.includes(col.value))
// //                     .map((col) => (
// //                       <TableCell key={col.value}>
// //                         {row[col.value] ?? "-"}
// //                       </TableCell>
// //                     ))}
// //                 </TableRow>
// //               ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //       </Box>

// //             {/* Pagination */}
// //       {totalPages > 0 && (
// //         <PaginationComponent
// //           page={page}                // ⭐ FIXED: use "page" instead of "currentPage"
// //           limit={itemsPerPage}       // ⭐ FIXED: pass limit if PaginationComponent expects it
// //           totalPages={totalPages}
// //           setPage={setPage}          // ⭐ FIXED: pass setPage (required by BulkSFATableProps)
// //         />
// //       )}

// //     </Box>
// //   );
// // };

// // export default BulkSFATable;
// import React, { useState, useRef } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Button,
//   Paper,
//   Box,
//   Typography,
//   TableSortLabel,
// } from "@mui/material";
// import DropDownFilter, { Option } from "./DropDownFilter";
// import PaginationComponent from "../../brands/Pagination";

// import Export from "../../../../src/assests/images/export.svg";
// import Sorting from "../../../../src/assests/images/Sorting.svg";
// import { exportSFAReport } from "./api";
// import { getToken } from "../../../utils/utils";

// export interface BulkSFATableProps {
//   data: any[];
//   loading: boolean;
//   page: number;
//   limit: number;
//   totalRecords: number;
//   setPage: (newPage: number) => void;
//   search?: string;
//   startDate?: Date | null;
//   endDate?: Date | null
// }

// const columns: Option[] = [
//   { label: "Id", value: "id" },
//   { label: "PMI Entity Code", value: "pmi_entity_code" },
//   { label: "Phone Number", value: "dte_contact_id" },
//   { label: "Created At", value: "createdAt" },
//   { label: "SFA ID", value: "sfa_id" },
//   { label: "Branch", value: "branch" },
//   { label: "M3 SFA Vol", value: "m3_sfa_vol" },
//   { label: "M2 SFA Vol", value: "m2_sfa_vol" },
//   { label: "Number of Bills Cut", value: "number_of_bills_cut" },
//   { label: "Advance Vol", value: "advance_vol" },
//   { label: "Fusebeyond Vol", value: "fusebeyond_vol" },
//   { label: "Gold Vol", value: "gold_vol" },
//   { label: "Red Vol", value: "red_vol" },
//   { label: "Clovemix Vol", value: "clovemix_vol" },
//   { label: "Finetouch Vol", value: "finetouch_vol" },
//   { label: "Vista Double Vol", value: "vista_doubleu_vol" },
//   { label: "Filterblack Vol", value: "filterblack_vol" },
//   { label: "Vistablue Vol", value: "vistablue_vol" },
//   { label: "Vistamist Vol", value: "vistamist_vol" },
//   { label: "Vista Taaza Vol", value: "vista_taaza_vol" },
//   { label: "Vista Tropical Vol", value: "vista_tropical_vol" },
//   { label: "Filterblack Kings Vol", value: "filterblack_kings_vol" },
//   { label: "Compactad Vol", value: "compactad_vol" },
//   { label: "Pocket Vol", value: "pocket_vol" },
//   { label: "Parlgold Vol", value: "parlgold_vol" },
//   { label: "Partltropical Vol", value: "partltropical_vol" },
//   { label: "Combeeyond Vol", value: "combeeyond_vol" },
//   { label: "TimeStamp", value: "timestamp" },
//   // Workzoy & availability
//   { label: "M3 Workzoy Ranging", value: "m3_workzoy_ranging" },
//   { label: "M2 Workzoy Ranging", value: "m2_workzoy_ranging" },
//   { label: "Advance Avl", value: "advance_avl" },
//   { label: "Fusebeyond Avl", value: "fusebeyond_avl" },
//   { label: "Gold Avl", value: "gold_avl" },
//   { label: "Red Avl", value: "red_avl" },
//   { label: "Clovemix Avl", value: "clovemix_avl" },
//   { label: "Finetouch Avl", value: "finetouch_avl" },
//   { label: "Vista Double Avl", value: "vista_doubleu_avl" },
//   { label: "Filterblack Avl", value: "filterblack_avl" },
//   { label: "Vistablue Avl", value: "vistablue_avl" },
//   { label: "Vistamist Avl", value: "vistamist_avl" },
//   { label: "Vista Taaza Avl", value: "vista_taaza_avl" },
//   { label: "Vista Tropical Avl", value: "vista_tropical_avl" },
//   { label: "Filterblack Kings Avl", value: "filterblack_kings_avl" },
//   { label: "Compactad Avl", value: "compactad_avl" },
//   { label: "Pocket Avl", value: "pocket_avl" },
//   { label: "Parlgold Avl", value: "parlgold_avl" },
//   { label: "Combeeyond Avl", value: "combeeyond_avl" },
//   { label: "Partltropical Avl", value: "partltropical_avl" },
//   {label:'Month/Year',value:'monthYear'}
// ];
// const defaultColumns = ["id", "pmi_entity_code","dte_contact_id", "timestamp", "sfa_id", "branch", "advance_vol", "fusebeyond_vol"];
// const token = getToken();

// const BulkSFATable: React.FC<BulkSFATableProps> = ({ data, loading, page, limit, totalRecords, setPage, search,
//   startDate,
//   endDate }) => {
//   const [selectedCols, setSelectedCols] = useState<string[]>(defaultColumns);

//   const [orderBy, setOrderBy] = useState<string>("");
//   const [order, setOrder] = useState<"asc" | "desc">("asc");
//   //   const itemsPerPage = 10;
//   const totalPages = Math.ceil(totalRecords / limit);
//   const [localSearch, setLocalSearch] = useState(search || "")
//   React.useEffect(() => {
//     setLocalSearch(search || "")
//   }, [search])
//   const handleSort = (property: keyof BulkSFATableProps) => {
//     const isAsc = orderBy === property && order === "asc";
//     setOrder(isAsc ? "desc" : "asc");
//     setOrderBy(property);
//   };

//   //   const paginatedUsers = (data || []).slice(
//   //     (page - 1) * itemsPerPage,
//   //     page * itemsPerPage
//   //   );
// //   const sortedRows = [...(data || [])].sort((a, b) => {
// //   let aVal = a[orderBy] ?? "";
// //   let bVal = b[orderBy] ?? "";

// //   // convert numbers if possible
// //   if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
// //     aVal = Number(aVal);
// //     bVal = Number(bVal);
// //   }

// //   if (aVal < bVal) return order === "asc" ? -1 : 1;
// //   if (aVal > bVal) return order === "asc" ? 1 : -1;
// //   return 0;
// // });
// //   const paginatedUsers = sortedRows
// // ⭐ Replace old sortedRows with this
// // const processedRows = React.useMemo(() => {
// //   if (!orderBy) return data || []; // default → API order

// //   return [...(data || [])].sort((a, b) => {
// //     let aVal = a[orderBy] ?? "";
// //     let bVal = b[orderBy] ?? "";

// //     if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
// //       aVal = Number(aVal);
// //       bVal = Number(bVal);
// //     }

// //     if (aVal < bVal) return order === "asc" ? -1 : 1;
// //     if (aVal > bVal) return order === "asc" ? 1 : -1;
// //     return 0;
// //   });
// // }, [data, orderBy, order]);
// const processedRows = React.useMemo(() => {
//   if (!orderBy) return data || [];

//   return [...(data || [])].sort((a, b) => {
//     let aVal = a[orderBy] ?? "";
//     let bVal = b[orderBy] ?? "";

//     // 1️⃣ Check if the column is timestamp/date
//     if (orderBy === "timestamp" || orderBy === "createdAt" || orderBy==="monthYear") {
//       // Convert DD-MM-YYYY or ISO to Date object
//       const parseDate = (val: string | Date) => {
//         if (!val) return new Date(0); // fallback
//         if (val instanceof Date) return val;
//         // Assume format "DD-MM-YYYY" → split and create date
//         const parts = val.split("-");
//         if (parts.length === 3) {
//           return new Date(+parts[2], +parts[1] - 1, +parts[0]); // year, monthIndex, day
//         }
//         return new Date(val); // fallback to Date parser
//       };
//       aVal = parseDate(aVal);
//       bVal = parseDate(bVal);
//     } else if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
//       // 2️⃣ Numbers
//       aVal = Number(aVal);
//       bVal = Number(bVal);
//     } else {
//       // 3️⃣ Strings → make lowercase for consistent sort
//       aVal = String(aVal).toLowerCase();
//       bVal = String(bVal).toLowerCase();
//     }

//     if (aVal < bVal) return order === "asc" ? -1 : 1;
//     if (aVal > bVal) return order === "asc" ? 1 : -1;
//     return 0;
//   });
// }, [data, orderBy, order]);

// const paginatedUsers = processedRows;

//   // const handleExportCSV = async () => {
//   //   try {
//   //     const reqBody = {
//   //       search: search?.trim() || "",
//   //       dateRange: {
//   //         from: startDate ? startDate.toLocaleDateString("en-CA") : "",
//   //         to: endDate ? endDate.toLocaleDateString("en-CA") : "",
//   //       },
//   //       page,
//   //       limit,
//   //     };

//   //     const res = await exportSFAReport(reqBody, token);

//   //     const disposition = res.headers["content-disposition"];
//   //     let filename = "sfa_report.xlsx";
//   //     if (disposition) {
//   //       const match = disposition.match(/filename="?(.+)"?/);
//   //       if (match?.[1]) filename = match[1];
//   //     }

//   //     const url = window.URL.createObjectURL(new Blob([res.data]));
//   //     const link = document.createElement("a");
//   //     link.href = url;
//   //     link.setAttribute("download", filename);
//   //     document.body.appendChild(link);
//   //     link.click();
//   //     link.remove();
//   //   } catch (error) {
//   //     console.error("Export failed:", error);
//   //   }
//   // };
//   const handleExportCSV = async () => {
//     try {
//       const reqBody = {
//         search: search?.trim() || "",
//         dateRange: {
//           from: startDate ? startDate.toLocaleDateString("en-CA") : "",
//           to: endDate ? endDate.toLocaleDateString("en-CA") : "",
//         },
//         page,
//         limit,
//         columns: selectedCols, // ✅ send selected columns
//       };

//       console.log("Export reqBody:", reqBody); // ✅ debug

//       const res = await exportSFAReport(reqBody, token);

//       const disposition = res.headers["content-disposition"];
//       let filename = "sfa_report.xlsx";
//       if (disposition) {
//         const match = disposition.match(/filename="?(.+)"?/);
//         if (match?.[1]) filename = match[1];
//       }

//       const url = window.URL.createObjectURL(new Blob([res.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//     } catch (error) {
//       console.error("Export failed:", error);
//     }
//   };



//   return (
//     <Box sx={{ background: "#fff", borderRadius: "10px", border: "1px solid #cfcfcf" }}>
//       <Box sx={{ padding: "25px ", display: "flex", justifyContent: "space-between" }}>
//         <Typography sx={{ fontSize: "16px", fontWeight: "600", marginTop: "10px" }}>
//           {loading ? "Loading..." : `Total ${totalRecords} Users`}
//         </Typography>
//         <Box sx={{ display: "flex" }}>
//           <Box sx={{ width: "200px", marginRight: "20px" }}>
//             <DropDownFilter
//               placeholder="Select columns"
//               options={columns}
//               value={selectedCols}
//               onChange={(cols) => {
//                 if (cols.includes("ALL")) { // ⭐ handle Select All click
//                   if (selectedCols.length === columns.length) {
//                     setSelectedCols(defaultColumns); // deselect → reset default
//                   } else {
//                     setSelectedCols(columns.map(c => c.value)); // select all
//                   }
//                 } else if (cols.length === 0) {
//                   setSelectedCols(defaultColumns); // ⭐ empty → reset default
//                 } else {
//                   setSelectedCols(cols);
//                 }
//               }}
//             />
//           </Box>
//           <Button
//             variant="contained"
//             sx={{
//               textTransform: "capitalize",
//               backgroundColor: "#fff",
//               fontSize: "14px",
//               fontWeight: "500",
//               height: "40px",
//               padding: "16px",
//               borderRadius: "10px",
//               color: "#C8172F",
//               border: "1px solid #C8172F",
//               boxShadow: "none",
//             }}
//             startIcon={<img src={Export} alt="export" />}
//             onClick={handleExportCSV}
//           >
//             Export CSV
//           </Button>
//         </Box>
//       </Box>

//       <Box>
//         <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
//           <Table>
//             <TableHead sx={{ background: "#EEF4FF" }}>
//               <TableRow>
//                 {columns
//                   .filter(col => selectedCols.includes(col.value))
//                   .map(col => (
//                     <TableCell key={col.value}>
//                       <TableSortLabel
//                         active={orderBy === col.value}
//                         direction={orderBy === col.value ? order : "asc"}
//                         onClick={() => handleSort(col.value as keyof BulkSFATableProps)}
//                         IconComponent={() => (
//                           <img src={Sorting} alt="sort" style={{ width: 16, height: 16 }} />
//                         )}
//                       >
//                         {col.label}
//                       </TableSortLabel>
//                     </TableCell>
//                   ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedUsers.length > 0 ? (
//                 paginatedUsers.map((row, rowIndex) => (
//                   <TableRow key={rowIndex}>
//                     {columns
//                       .filter(col => selectedCols.includes(col.value))
//                       .map(col => (
//                         <TableCell key={col.value}sx={{
//                                 whiteSpace: "nowrap",   // 👈 prevents wrapping
                                                        
//                            }}>
//                           {row[col.value] ?? "-"}
//                         </TableCell>
//                       ))}
//                   </TableRow>
//                 ))
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={selectedCols.length} align="center">
//                     No Data Found
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Box>

//       {/* {totalPages > 0 && ( */}
//       <PaginationComponent
//         page={page}
//         limit={limit}
//         totalPages={totalPages}
//         setPage={setPage}

//       />
//       {/* )} */}
//     </Box>
//   );
// };

// export default BulkSFATable;
import React, { useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
  Box,
  Typography,
  TableSortLabel,
} from "@mui/material";
import DropDownFilter, { Option } from "./DropDownFilter";
import PaginationComponent from "../../brands/Pagination";

import Export from "../../../../src/assests/images/export.svg";
import Sorting from "../../../../src/assests/images/Sorting.svg";
import { exportSFAReport } from "./api";
import { getToken } from "../../../utils/utils";

export interface BulkSFATableProps {
  data: any[];
  loading: boolean;
  page: number;
  limit: number;
  totalRecords: number;
  setPage: (newPage: number) => void;
  search?: string;
  startDate?: Date | null;
  endDate?: Date | null;
}

const columns = [
  { label: "ID", value: "id" },
  { label: "PMI Entity Code", value: "pmi_entity_code" },
  { label: "Phone", value: "dte_contact_id" },
  { label: "Created At", value: "createdAt" },
  { label: "Updated At", value: "updatedAt" },
  { label: "Target Month/Year", value: "target_month_year" },
  { label: "Actual Month/Year", value: "actual_month_year" },
  { label: "Overall Target", value: "overall" },

  // 🔥 Neater labels, all same data keys
  { label: "Marlboro Red", value: "marlboro_red/target_marlboro_red", isActualTarget: true },
  { label: "Marlboro Gold", value: "marlboro_gold/target_marlboro_gold", isActualTarget: true },
  { label: "Marlboro Gold Advance", value: "marlboro_gold_advance/target_marlboro_gold_advance", isActualTarget: true },
  { label: "Marlboro Fuse Beyond", value: "marlboro_fuse_beyond/target_marlboro_fuse_beyond", isActualTarget: true },
  { label: "Marlboro Clove Mix", value: "marlboro_clove_mix/target_marlboro_clove_mix", isActualTarget: true },
  { label: "Marlboro Vista Forest Fusion", value: "marlboro_vista_forest_fusion/target_marlboro_vista_forest_fusion", isActualTarget: true },
  { label: "Total", value: "total_actual_vol/total_target_vol", isActualTarget: true },
];

const defaultColumns = [
  "id",
  "pmi_entity_code",
  "dte_contact_id", 
  "marlboro_red/target_marlboro_red", 
  "marlboro_gold/target_marlboro_gold",
  "marlboro_gold_advance/target_marlboro_gold_advance",
  "marlboro_fuse_beyond/target_marlboro_fuse_beyond",
  "marlboro_clove_mix/target_marlboro_clove_mix",
  "marlboro_vista_forest_fusion/target_marlboro_vista_forest_fusion",
  "total_actual_vol/total_target_vol"
]
const token = getToken();

const BulkSFATable: React.FC<BulkSFATableProps> = ({
  data,
  loading,
  page,
  limit,
  totalRecords,
  setPage,
  search,
  startDate,
  endDate,
}) => {
  const [selectedCols, setSelectedCols] = useState<string[]>(defaultColumns);
  const [orderBy, setOrderBy] = useState<string>("");
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const totalPages = Math.ceil(totalRecords / limit);
  const [localSearch, setLocalSearch] = useState(search || "");

  React.useEffect(() => {
    setLocalSearch(search || "");
  }, [search]);

  const handleSort = (property: keyof BulkSFATableProps) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const processedRows = React.useMemo(() => {
    if (!orderBy) return data || [];

    return [...(data || [])].sort((a, b) => {
      let aVal = a[orderBy] ?? "";
      let bVal = b[orderBy] ?? "";

      if (orderBy === "timestamp" || orderBy === "createdAt" || orderBy === "monthYear") {
        const parseDate = (val: string | Date) => {
          if (!val) return new Date(0);
          if (val instanceof Date) return val;
          const parts = val.split("-");
          if (parts.length === 3) {
            return new Date(+parts[2], +parts[1] - 1, +parts[0]);
          }
          return new Date(val);
        };
        aVal = parseDate(aVal);
        bVal = parseDate(bVal);
      } else if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
        aVal = Number(aVal);
        bVal = Number(bVal);
      } else {
        aVal = String(aVal).toLowerCase();
        bVal = String(bVal).toLowerCase();
      }

      if (aVal < bVal) return order === "asc" ? -1 : 1;
      if (aVal > bVal) return order === "asc" ? 1 : -1;
      return 0;
    });
  }, [data, orderBy, order]);

  const paginatedUsers = processedRows;

  const handleExportCSV = async () => {
    try {
      const reqBody = {
        search: search?.trim() || "",
        dateRange: {
          from: startDate ? startDate.toLocaleDateString("en-CA") : "",
          to: endDate ? endDate.toLocaleDateString("en-CA") : "",
        },
        page,
        limit,
        columns: selectedCols,
      };

      const res = await exportSFAReport(reqBody, token);
      const disposition = res.headers["content-disposition"];
      let filename = "sfa_report.xlsx";
      if (disposition) {
        const match = disposition.match(/filename="?(.+)"?/);
        if (match?.[1]) filename = match[1];
      }

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  return (
    <Box sx={{ background: "#fff", borderRadius: "10px", border: "1px solid #cfcfcf" }}>
      <Box sx={{ padding: "25px ", display: "flex", justifyContent: "space-between" }}>
        <Typography sx={{ fontSize: "16px", fontWeight: "600", marginTop: "10px" }}>
          {loading ? "Loading..." : `Total ${totalRecords} Users`}
        </Typography>

        <Box sx={{ display: "flex" }}>
          <Box sx={{ width: "200px", marginRight: "20px" }}>
            <DropDownFilter
              placeholder="Select columns"
              options={columns}
              value={selectedCols}
              onChange={(cols) => {
                if (cols.includes("ALL")) {
                  if (selectedCols.length === columns.length) {
                    setSelectedCols(defaultColumns);
                  } else {
                    setSelectedCols(columns.map((c) => c.value));
                  }
                } else if (cols.length === 0) {
                  setSelectedCols(defaultColumns);
                } else {
                  setSelectedCols(cols);
                }
              }}
            />
          </Box>

          <Button
            variant="contained"
            sx={{
              textTransform: "capitalize",
              backgroundColor: "#fff",
              fontSize: "14px",
              fontWeight: "500",
              height: "40px",
              padding: "16px",
              borderRadius: "10px",
              color: "#C8172F",
              border: "1px solid #C8172F",
              boxShadow: "none",
            }}
            startIcon={<img src={Export} alt="export" />}
            onClick={handleExportCSV}
          >
            Export CSV
          </Button>
        </Box>
      </Box>

      <Box>
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table>
            <TableHead sx={{ background: "#EEF4FF" }}>
              <TableRow>
                {columns
                  .filter((col) => selectedCols.includes(col.value))
                  .map((col) => (
                    <TableCell key={col.value} sx={{ whiteSpace: "nowrap" }}>
                      <TableSortLabel
                        active={orderBy === col.value}
                        direction={orderBy === col.value ? order : "asc"}
                        onClick={() => handleSort(col.value as keyof BulkSFATableProps)}
                        IconComponent={() => (
                          <img src={Sorting} alt="sort" style={{ width: 16, height: 16 }} />
                        )}
                      >
                        {/* 🔥 CHANGED — Neater label rendering */}
                        {col.isActualTarget ? (
                          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", lineHeight: 1.2 }}>
                            <Typography sx={{ fontWeight: 600, fontSize: "13px" }}>
                              {col.label}
                            </Typography>
                            <Typography sx={{ fontSize: "11px", color: "#666" }}>
                              (Actual / Target)
                            </Typography>
                          </Box>
                        ) : (
                          col.label
                        )}
                      </TableSortLabel>
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {paginatedUsers.length > 0 ? (
                paginatedUsers.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {columns
                      .filter((col) => selectedCols.includes(col.value))
                      .map((col) => (
                        <TableCell
                          key={col.value}
                          sx={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          {row[col.value] ?? "-"}
                        </TableCell>
                      ))}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={selectedCols.length} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <PaginationComponent page={page} limit={limit} totalPages={totalPages} setPage={setPage} />
    </Box>
  );
};

export default BulkSFATable;
